export const CARD_BORDER_TYPE = {
  SOLID: 'solid',
  DUBBLE: 'double',
  DOTTED: 'dotted',
  DASHED: 'dashed',
} as const;

export const CARD_BORDER_MAP = {
  [CARD_BORDER_TYPE.SOLID]: '기본',
  [CARD_BORDER_TYPE.DUBBLE]: '두줄',
  [CARD_BORDER_TYPE.DOTTED]: '도트',
  [CARD_BORDER_TYPE.DASHED]: '대쉬',
};

export type CARD_BORDER_TYPE_KEY = keyof typeof CARD_BORDER_TYPE;
export type CARD_BORDER_TYPE_VALUE =
  typeof CARD_BORDER_TYPE[CARD_BORDER_TYPE_KEY];

export const cardBorderTypeList = Object.keys(CARD_BORDER_MAP).map((key) => {
  return {
    key: key,
    value: CARD_BORDER_MAP[key],
  };
});
